import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "min-w-[225px] max-w-[225px] max-h-[350px] m-[10px] h-[350px] shadow-4xl p-[5px] rounded-[30px] flex flex-col items-center justify-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "text-sm text-gray-700 text-center" }


export default /*#__PURE__*/_defineComponent({
  __name: 'One_training',
  props: {
    trainings: {}
  },
  setup(__props: any) {

    const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.trainings, (training) => {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("img", {
        src: training.image,
        alt: "",
        class: "w-[65px] h-[65px] rounded-[50%] p-[1px] border border-cyan-600 border-spacing-2"
      }, null, 8, _hoisted_2),
      _createElementVNode("a", {
        href: training.link,
        class: "text-cyan-500 text-center text-xl my-[10px]"
      }, _toDisplayString(training.title), 9, _hoisted_3),
      _createElementVNode("p", _hoisted_4, _toDisplayString(training.content), 1)
    ]))
  }), 256))
}
}

})